import { render, staticRenderFns } from "./data-migrate.vue?vue&type=template&id=1b88189c&scoped=true&"
import script from "./data-migrate.vue?vue&type=script&lang=js&"
export * from "./data-migrate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b88189c",
  null
  
)

export default component.exports